// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Ghk1","messages":"Chat_messages__23jE4","dateDivider":"Chat_dateDivider__1ZZUW"};